import { PageBody } from '@root/Design/Layout';
import { ReactNode } from 'react';

export function HomeShell(props: { children: ReactNode }) {
    return <PageBody>{props.children}</PageBody>;
}
